<div class="row">
	<div class="col-xs-12 actions-col">
		<a href="/apps/{{appId}}/search-terms/new"><button class="button wide add">{{t "common.add"}}</button></a>
		<button class="button wide js-import ml-10">{{t "translations.importExport.import"}}</button>
	</div>

	<input type="file" class="js-import-input" name="files" accept=".csv" style="display: none;">

</div>
